import { webServiceCall } from "./pantherService";

export const validateClientGUID = async (guid) => {
  try {
    const storedClient = localStorage.getItem("clientData");
    if (storedClient) {
      const client = JSON.parse(storedClient);
      if (client.GUId === guid) return true;
    }
    const result = await webServiceCall("GetClientGUIDIsValid", { GUId: guid });

    if (!result) return false;

    const { valid } = typeof result === "string" ? JSON.parse(result.trim()) : result;

    return valid === true;
  } catch (e) {
    console.error("validateClientGUID failed", e);
    return false;
  }
};